export default [
  // Order Tender and inquiries
  {
    path: '/gop/inquiries-demands/create',
    name: 'order-inquiries-demands.create',
    component: () => import('@/pages/Order/Inquiries/Create'),
    meta: {
      perimeter: 'OpsLogPerimeter',
    },
  },

  {
    path: '/gop/inquiries-demands/edit/:id',
    name: 'order-inquiries-demands.edit',
    component: () => import('@/pages/Order/Inquiries/Edit'),
    meta: {
      perimeter: 'OpsLogPerimeter',
    },
  },

  {
    path: '/gop/inquiries-demands/distribute/:id',
    name: 'order-inquiries-demands.distribute',
    component: () => import('@/pages/Order/Inquiries/Distribute'),
    meta: {
      perimeter: 'OpsLogPerimeter',
    },
  },

  {
    path: '/gop/inquiries-demands/results/:id',
    name: 'order-inquiries-demands.results',
    component: () => import('@/pages/Order/Inquiries/Results'),
    meta: {
      perimeter: 'OpsLogPerimeter',
    },
  },

  {
    path: '/gop/inquiries-demands/results',
    name: 'order-inquiries-demands.results.list',
    component: () => import('@/pages/Order/Inquiries/IndexResults'),
    meta: {
      perimeter: 'OpsLogPerimeter',
    },
  },

  {
    path: '/gop/inquiries-demands',
    name: 'order-inquiries-demands.index',
    component: () => import('@/pages/Order/Inquiries/Index'),
    meta: {
      perimeter: 'OpsLogPerimeter',
    },
  },
];



// WEBPACK FOOTER //
// ./src/routes/order.js